import { Injectable } from '@angular/core';
import { catchAndContinue, filterUndefined } from 'src/app/lego-utils';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { Connector } from 'src/app/models/domain';
import { ConnectorDataService } from 'src/app/services';
import { handleError } from 'src/app/state/akita-error-helper';
import { CollectionState } from 'src/app/state/collection-state';
import { DesignService } from 'src/app/state/design.service';

@Injectable({
  providedIn: 'root',
})
export class ConnectorService {
  private readonly state = new CollectionState<Connector>();

  public readonly connectors$ = this.state.items$;
  public readonly error$ = this.state.error$;

  /** The connector table is only ready once the design it hangs off has loaded. */
  public readonly loading$: Observable<boolean> = combineLatest([
    this.designService.loading$,
    this.state.loading$,
  ]).pipe(map(([designLoading, connectorLoading]) => designLoading || connectorLoading));

  public constructor(
    private readonly designService: DesignService,
    private readonly connectorDataService: ConnectorDataService
  ) {}

  public loadBySuperDesign() {
    return this.designService.superDesign$.pipe(
      filterUndefined(() => {
        this.state.reset();
      }),
      tap(() => {
        this.state.setLoading(true);
      }),
      switchMap((superDesign) =>
        catchAndContinue(
          this.connectorDataService.getConnectorsBySuperDesign(superDesign),
          (error) => {
            handleError(this.state, error);
          }
        )
      ),
      tap((connectors) => {
        this.state.set(connectors);
      }),
      map(() => undefined)
    );
  }

  public reset() {
    this.state.reset();
  }
}
